import { Component, OnInit, AfterViewChecked, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { PigmentService, Pigment } from "../../../services/pigment.service";
import { BaseComponent } from "../../base.component";
import { PaginationService } from "app/services/pagination.service";
import { NotificationsService } from "angular2-notifications";

@Component({
  selector: 'app-pigment',
  templateUrl: './pigment.component.html',
  styleUrls: ['./pigment.component.css']
})
export class PigmentComponent extends BaseComponent implements OnInit {
	pigments:any[];
	pigment:Pigment;
	cur_pigment:Pigment;

	formTitle:string;
	buttonTitle:string;

	pager: any = {};
	pagedItems: any[];

	pigmentForm: NgForm;
	@ViewChild('pigmentForm') currentForm: NgForm;

	constructor(
		private pigmentService: PigmentService,
		private paginationService: PaginationService,
		private notificationsService: NotificationsService,
	) {
		super();
	}

	ngOnInit() {
		this.pigmentService.getPigments().subscribe((pigments) => {
			this.pigments = pigments.sort((a,b)=> {
				if(a.name == b.name)
				{
					return 0;
				}
				return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
			})
			this.setPage(1);
		});
		this.pigment = new Pigment();
		
	}

	setPage(page: number) {
        // get pager object from service
        this.pager = this.paginationService.getPager(this.pigments.length, page);

        // get current page of items
        this.pagedItems = this.pigments.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }

	clickEdit(pigment)
	{
		this.formTitle = 'Edit Pigment';
		this.buttonTitle = 'Update Pigment';
		this.cur_pigment = pigment;
		this.pigment = Object.assign(new Pigment(), pigment);
	}

	clickAdd()
	{
		this.formErrors.name = '';
		this.formTitle = 'Add New Pigment';
		this.buttonTitle = 'Save Pigment';
		this.pigment = new Pigment();
		this.cur_pigment = null;
	}

	onDeleteClick(key) {
		var self = this;
		if (confirm('Are you sure?')) {
			this.pigmentService.deletePigment(key).then(function(){
				self.notificationsService.error('Deleted', '1 pigment deleted')
			});
		}
	}

	formAction()
	{
		var form_element = <HTMLFormElement>document.getElementById("form");
		var self = this;
		if(this.pigment)
		{
			if(this.formValidation(false)){
				if(!this.cur_pigment)
				{
					this.pigmentService.addPigment(this.pigment).then(function(){
						self.notificationsService.success('Added', '1 pigment added')
						form_element.reset();
					}).catch(function(e){
						console.log(e.message)
					});
				}
				else
				{
					this.pigmentService.updatePigment(this.cur_pigment.$key, this.pigment).then(function(){
						self.notificationsService.success('Updated', '1 pigment updated')
						form_element.reset();
					}).catch(function(e){
						console.log(e.message)
					});
				}
			}
		}
	}

	ngAfterViewChecked() {
		this.formChanged();
	}

	formChanged() {
		if (this.currentForm === this.pigmentForm) { return; }

		this.pigmentForm = this.currentForm;
		if (this.pigmentForm) {
			this.pigmentForm.valueChanges
				.subscribe(data => {
					this.formValidation(true)
				});
		}
	}

	formValidation(checkDirty = true) {
		const form = this.pigmentForm.form;
		for (const field in form.controls) {
			const control = form.get(field)
			if (control) {
				if (checkDirty && !control.dirty) {
					continue;
				}
				this.formErrors[field] = '';
				if (!control.valid) {
					const messages = this.validationMessages[field] || {};
					for (const key in control.errors) {
						this.formErrors[field] += messages[key] + ' ';
					}
				}
			}
		}
		return form.valid;
	}

	formErrors = {
		'name' : ''
	};

	validationMessages = {
		'name': {
			'required': 'This field is required.',
		}
	};
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/pigment/pigment/pigment.component.ts